export default __webpack_public_path__ + "static/media/group.d096d33f.png";